import { render, staticRenderFns } from "./ShowShop.vue?vue&type=template&id=6986ab58&scoped=true&"
import script from "./ShowShop.vue?vue&type=script&lang=js&"
export * from "./ShowShop.vue?vue&type=script&lang=js&"
import style0 from "./ShowShop.vue?vue&type=style&index=0&id=6986ab58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6986ab58",
  null
  
)

export default component.exports